import { render, staticRenderFns } from "./RecuperarSenhaConfirmar.vue?vue&type=template&id=16ee0e56&scoped=true"
import script from "./RecuperarSenhaConfirmar.vue?vue&type=script&lang=js"
export * from "./RecuperarSenhaConfirmar.vue?vue&type=script&lang=js"
import style0 from "./RecuperarSenhaConfirmar.vue?vue&type=style&index=0&id=16ee0e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ee0e56",
  null
  
)

export default component.exports